import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { init, loadItems, loadSuccess, openPage, setPageCount } from './enriched-watchlist.actions';
import { EnrichmentData, ItemCategory } from './enriched-watchlist.models';

import { selectWatchlistItemId } from '../watchlist/watchlist.reducer';

export const ENRICHED_WATCHLIST_FEATURE_KEY = 'enrichedWatchlist';

export interface EnrichedWatchlistState extends EntityState<EnrichmentData> {
  loaded: boolean; // has the EnrichedWatchlist list been loaded,
  itemCategory: ItemCategory;
  currentPage: number;
  pageCount: number;
  itemsOnPage: EnrichmentData[];
  itemCount: number;
  cachedItems: EnrichmentData[];
}

export interface EnrichedWatchlistPartialState {
  readonly [ENRICHED_WATCHLIST_FEATURE_KEY]: EnrichedWatchlistState;
}

export const enrichedWatchlistAdapter: EntityAdapter<EnrichmentData> = createEntityAdapter<EnrichmentData>();

export const initialEnrichedWatchlistState: EnrichedWatchlistState = enrichedWatchlistAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  itemCategory: ItemCategory.all,
  currentPage: 0,
  pageCount: 1,
  itemsOnPage: [],
  itemCount: 0,
  cachedItems: [],
});

const reducer = createReducer(
  initialEnrichedWatchlistState,
  on(openPage, (state, { page }) => ({
    ...state,
    loaded: false,
    currentPage: page,
  })),
  on(init, (state, { page, itemCategory }) => ({
    ...state,
    loaded: false,
    currentPage: page,
    itemCategory,
  })),
  on(setPageCount, (state, { pageCount }) => ({
    ...state,
    pageCount,
  })),
  on(loadItems, (state, { items }) => ({
    ...state,
    itemCount: items.length,
  })),
  on(loadSuccess, (state, { enrichedItems }) => ({
    ...state,
    loaded: true,
    itemsOnPage: enrichedItems,
    cachedItems: [
      ...state.cachedItems,
      ...enrichedItems.filter(
        (item) =>
          !state.cachedItems.find((cachedItem) => selectWatchlistItemId(cachedItem) === selectWatchlistItemId(item))
      ),
    ],
  }))
);

export function enrichedWatchlistReducer(state: EnrichedWatchlistState | undefined, action: Action) {
  return reducer(state, action);
}
